export const TEMPLATE_NAMES = {
  PDP: 'AccommodationPage',
}

export const BRAND = {
  SUNWEB: 'sunweb',
  ELIZA: 'eliza',
}
